import * as React from 'react';
import { ItemCart, SizeGuide } from './iCart';
import Modal from 'react-responsive-modal';
import{ TranslationProps, WithTranslation } from "../../contexts/TranslationContext";

interface GuideTailleProps extends TranslationProps {
  item: ItemCart;
}

interface GuideTailleState {
  open: boolean;
}

class RenderGuideTaille extends React.Component<GuideTailleProps, GuideTailleState> {

  constructor(props: GuideTailleProps) {
    super(props);
    this.state = {
      open: false,
    };
  }

  onOpenModal = () => {
    this.setState({ open: true });
  }

  onCloseModal = () => {
    this.setState({ open: false });
  }

  render() {
    const renderTitleModal = () => {
      return (
        <h2 className="titleModal">{this.props.textsContent?.[`CART_SIZE_GUIDE_TITLE`] ?? 'Guide des tailles'}</h2>
      );
    };

    const renderTitleItem = () => {
      return (
        <h3 className="font14">
          <span className="text-capitalize">{this.props.item.guideTaille.product.marque + ' - '}</span>
          <span>{this.props.item.guideTaille.product.titre_produit + ' - '}</span>
          <span className="grey">{'(' + this.props.item.guideTaille.product.reference_visible + ')'}</span>
        </h3>
      );
    };

    const renderLogoMarque = () => {
      return (
        <div>
          <img 
            src={'/images/marques/70x70/' + this.props.item.guideTaille.product.logo_marque}
            alt={'Logo de la marque' + this.props.item.guideTaille.product.marque}
          />
        </div>
      );
    };

    const renderHeaderModal = () => {
      return (
        <div className="d-flex mb2 headerModal">
          {renderLogoMarque()}

          <div className="pl1">
            {renderTitleModal()}
            {renderTitleItem()}
          </div>
        </div>
      );
    };

    const renderTheadGuide = () => {
      if (this.props.item.guideTaille.taille_article_format) {
        if (this.props.item.guideTaille.taille_article_format[0] != 'Mesures') {
          this.props.item.guideTaille.taille_article_format.unshift('Mesures');
        }

        const renderTh = this.props.item.guideTaille.taille_article_format.map((taille: string, index) => {
          return (<th key={index} className="pa05">{taille}</th>);
        });

        return (
          <thead>
          <tr>
            {renderTh}
          </tr>
          </thead>
        );
      }
    };

    const renderTbodyGuide = () => {
      if (this.props.item.guideTaille.sizeGuide) {
        const sizeGuide: SizeGuide & {[key: string]: any} = this.props.item.guideTaille.sizeGuide;
        const rows = Object.keys(sizeGuide).map((item, index1: number) => {

          const renderTd = sizeGuide[item].map((value: string, index2: number) => {
            return (<td key={index1 + '' + index2} className="pa05">{value}</td>);
          });

          return (
            <tr key={index1}>
              <td className="pa05">{item}</td>
              {renderTd}
            </tr>
          );

        });
        return (<tbody>{rows}</tbody>);
      }
    };

    const renderTableGuideTaille = () => {
      return (
        <div>
          <table className="tableGuideTaille">
            {renderTheadGuide()}
            {renderTbodyGuide()}
          </table>
          <p className="font11 grey text-center">{this.props.textsContent?.['CART_SIZE_GUIDE_EXPLAIN_TOLERANCE']}</p>
        </div>
      );
    };

    const renderLinkTaille = () => {
      if (!Array.isArray(this.props.item.guideTaille.sizeGuide) || this.props.item.lienPDFTaille) {
        return (
          <a
            id={'itemLinkTaille-' + this.props.item.article.produit.reference_visible}
            className="fancyzoom2 itemLinkTaille grey small text-underline "
            title={this.props.textsContent?.['CART_SIZE_GUIDE_TITLE']}
            onClick={this.onOpenModal}
          >
            <u>{this.props.textsContent?.['CART_LINE_CHECK_SIZE_GUIDE']}</u>
          </a>
        );
      }

      return '';
    };

    const renderTheadIndiceTaille = () => {
      return (
        <thead>
        <tr>
          <td>{this.props.textsContent?.['CART_SIZE_GUIDE_SMALL']}</td>
          <td>{this.props.textsContent?.['CART_SIZE_GUIDE_NORMAL']}</td>
          <td>{this.props.textsContent?.['CART_SIZE_GUIDE_TALL']}</td>
        </tr>
        </thead>
      );
    };

    const renderTbodyIndiceTaille = () => {
      const defineClassName = () => {
        let className = '';
        if (this.props.item.guideTaille.indiceTaille <= -19 ||
          (this.props.item.guideTaille.indiceTaille >= -5.5 && this.props.item.guideTaille.indiceTaille <= 5.5) ||
          this.props.item.guideTaille.indiceTaille >= 19) {
          className += ' point_actif';
        }

        return className;
      };

      return (
        <tbody>
        <tr>
          <td>
            <div className={'point_left' + defineClassName()}>&#8203;</div>
          </td>
          <td>
            <div className={'point_center' + defineClassName()}>&#8203;</div>
          </td>
          <td>
            <div className={'point_right' + defineClassName()}>&#8203;</div>
          </td>
        </tr>
        </tbody>
      );
    };

    const renderTableIndiceTaille = () => {
      return (
        <table>
          {renderTheadIndiceTaille()}
          {renderTbodyIndiceTaille()}
        </table>
      );
    };

    const renderJaugeIndiceTaille = () => {
      const styleJaugeIndiceTaille = {
        left: this.props.item.guideTaille.indiceTaille * 4.3 + '%',
      };

      return (
        <div className="bloc_jauge">
          <div className="cursor_jauge" style={styleJaugeIndiceTaille}>&#8203;</div>
        </div>
      );
    };

    const renderBlocIndiceTaille = () => {
      return (
        <div>
          <div className="bloc_indice_taille">
            {renderTableIndiceTaille()}
            {renderJaugeIndiceTaille()}
          </div>
          <p className="font11 grey text-center">{this.props.textsContent?.['CART_SIZE_GUIDE_DISCLAIMER']}</p>
        </div>
      );
    };

    const renderMessageBottomModal = () => {
      return (
        <p className=" font11 mt2 text-center bg-black white  pa05">{this.props.textsContent?.['CART_SIZE_GUIDE_EXPLAIN_TOLERANCE']}</p>
      );
    };

    const renderImgGuideTaille = () => {
      return (
        <img src={this.props.item.lienPDFTaille} className="imgGuideTaille"/>
      );
    };

    const renderContentModal = () => {
      if (!Array.isArray(this.props.item.guideTaille.sizeGuide)) {
        return (
          <div className="conteneurSizeGuide">
            {renderHeaderModal()}
            {renderTableGuideTaille()}
            {renderBlocIndiceTaille()}
          </div>
        );
      }
      if (this.props.item.lienPDFTaille) {
        return renderImgGuideTaille();
      }
    };

    const renderModal = () => {
      return (
        <Modal classNames={{ overlay: 'bootstrap-container' }} open={this.state.open} onClose={this.onCloseModal} center>
          <div className="modalGuideTaille">
            {renderContentModal()}
            {renderMessageBottomModal()}
          </div>
        </Modal>
      );
    };

    if (this.props.item.guideTaille.product) {
      return (
        <span>
          {renderLinkTaille()}
          {renderModal()}
        </span>
      );
    }

    return (<span></span>);
  }
} export default WithTranslation<GuideTailleProps>(RenderGuideTaille, 'CART_TUNNEL');
